import { createFileRoute } from '@tanstack/react-router';
import { BidManagementPage } from '@/pages/BidManagement';

export const Route = createFileRoute('/_admin/bid-management')({
  component: BidManagementPage,
});
